import { render } from "./Logos.vue?vue&type=template&id=b69d4f00&scoped=true"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"

import "./Logos.vue?vue&type=style&index=0&id=b69d4f00&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69d4f00"]])

export default __exports__